// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"a9e1e578","453":"0823246d"}[chunkId] + ".chunk.js";
};